import React, { useContext } from 'react';
import { ThemeContext } from '@lib/context/ThemeContextWrapper';

const DynamicStylesheet = () => {
  const { theme } = useContext(ThemeContext);

  const basePath = process.env.BASEPATH || '';

  const rawStylesheet = theme?.stylesheet;

  // Prefix BASEPATH to ensure stylesheets are retrieved from the correct environment
  const currentStylesheet =
    rawStylesheet && !rawStylesheet.startsWith('http') ? `${basePath}${rawStylesheet}` : rawStylesheet;

  return (
    <link
      href={`${currentStylesheet}?v=${encodeURIComponent(process.env.REACT_APP_UI_VERSION ?? '')}`}
      rel="stylesheet"
    />
  );
};

export default DynamicStylesheet;
